module.exports = __webpack_public_path__ + "img/expired.7c764cd2.png";